import React from "react";
import { useTranslation } from "react-i18next";
import FontAwesome from "react-fontawesome";
import Logo from "../../config/images/Neutral Markets Logo - Light.png";

const Home = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column", // stack vertically
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <img
        src={Logo}
        alt="Neutral Markets"
        style={{ width: "400px", height: "auto" }}
      />
      <h1>{t("Maintenance")}</h1>
      <FontAwesome
        name="screwdriver-wrench"
        style={{ fontSize: "3rem", marginBottom: "1rem" }}
      />
    </div>
  );
};

export default Home;
